import React from 'react';
import Button, { ButtonModeE } from '../../components/Button/Button';
import usePopup from '../../utils/hooks/usePopup';

import styles from './createNewBrandShort.module.scss';

const CreateNewBrandShortFooter = () => {
    const { removePopup } = usePopup();
    
    return (
        <div className={styles.buttonsWrapper}>
            <Button mode={ButtonModeE.OUTLINED} onClick={removePopup}>Cancel</Button>
            <Button form='create-brand-short' useGlobalLoading >Save brand</Button>
        </div>
    );
};

export default CreateNewBrandShortFooter;